export default "__VITE_ASSET__CX4FSilP__"